















































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getSchoolInfo } from '@/utils/utils';
import config from '@/school.config';
import moment from 'moment';
import ApplicationFormModalParents from './ApplicationFormModalParents.vue';
import { KunshanApplicationController, DropDownController } from '../services/request.service';
@Component({
  components: {
    ApplicationFormModalParents,
  },
})
export default class ParentDetail extends Vue {
  @Prop() public readonly studentDetailInfo!: any;
  @Prop() public readonly parentDetailInfo!: any;
  @Prop() public readonly guardianDetailInfo!: any;
  @Prop({ default: true }) public isShow!: boolean;
  @Prop() public detail!: boolean;
  @Prop() public isShowSchool!: boolean;

  // public guardianDetailInfo: any={};
  public emergencyDetailInfo: any = {};
  public moment = moment;
  public config = config;
  public isEdit: boolean = false;
  public isSupportEditMode: boolean = true;
  public visible = false;
  public confirmLoading = false;
  public sourceIsOther = false;
  public formValues: any = {};
  public isWrong: boolean = true;
  public data: any = {};
  public guardianData: any = {};
  public areaCode: string = '86';
  public accountAreaCode: string = '86';
  public areaCodeKey: number = 1;
  public accountAreaCodeKey: number = 1;
  public isOneParent: boolean = true;
  public emergencyContactResponse: any = {};

  @Watch('parentDetailInfo', { immediate: true })
  public onParentDetailInfoChange(newVal): void {
    if (newVal) {
      this.data = {
        ...newVal,
        guardianName: newVal.guardianResponse ? newVal.guardianResponse.name : undefined,
        guardianEnName: newVal.guardianResponse ? newVal.guardianResponse.enName : undefined,
        guardianMobile: newVal.guardianResponse ? newVal.guardianResponse.mobile : undefined,
        guardianRelationship: newVal.guardianResponse ? newVal.guardianResponse.relationship : undefined,
        guardianCountryId: newVal.guardianResponse ? newVal.guardianResponse.countryId : undefined,
        guardianHighestQualification: newVal.guardianResponse
          ? newVal.guardianResponse.highestQualification
          : undefined,
        guardianGraduatedFrom: newVal.guardianResponse ? newVal.guardianResponse.graduatedFrom : undefined,
        guardianWorkUnit: newVal.guardianResponse ? newVal.guardianResponse.workUnit : undefined,
        guardianPosition: newVal.guardianResponse ? newVal.guardianResponse.position : undefined,
        guardianEmail: newVal.guardianResponse ? newVal.guardianResponse.email : undefined,
        emergencyName: newVal.emergencyContactResponse ? newVal.emergencyContactResponse.name : undefined,
        emergencyRelationship: newVal.emergencyContactResponse
          ? newVal.emergencyContactResponse.relationship
          : undefined,
        emergencyRelationshipName: newVal.emergencyContactResponse
          ? newVal.emergencyContactResponse.relationshipName
          : undefined,
        emergencyRelationshipEnName: newVal.emergencyContactResponse
          ? newVal.emergencyContactResponse.relationshipEnName
          : undefined,
        emergencyMobile: newVal.emergencyContactResponse ? newVal.emergencyContactResponse.mobile : undefined,
        emergencyEmail: newVal.emergencyContactResponse ? newVal.emergencyContactResponse.email : undefined,
      };
      this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(newVal.sourceId) ? true : false;
      // this.guardianDetailInfo = this.data.guardianResponse ? this.data.guardianResponse : {};

      // if (this.data.emergencyContactResponse) {
      //   this.emergencyContactResponse = this.data.emergencyContactResponse;
      //   // this.data.emergencyContactFlag=true
      // } else {
      //   this.emergencyContactResponse = {};
      //   // this.data.emergencyContactFlag=false

      // }
      this.isOneParent = newVal.guardianResponse && newVal.guardianResponse.mobile ? false : true;
    }
  }

  public created() {
    this.$store.dispatch('getMemberShipList');
    this.$store.dispatch('getAcademicQualificationList');
  }
  public get school() {
    return getSchoolInfo().shortName;
  }
  //  public getAcademicQualificationList(): void {
  //   DropDownController.getAcademicQualificationList()
  //     .then((res: any) => {
  //       this.academicQualificationList = res.data;
  //     })
  //     .catch((error: any) => {});
  // }
  public emergencyContactFlagChange(value) {
    if (value === true) {
      this.emergencyContactResponse = {};
    }
  }
  public get rules() {
    return {
      emergencyName: [{ required: true, message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      emergencyRelationship: [{ required: true, message: this.$tc('pleaseSelect') }],
      emergencyEmail: [{ required: true, message: this.$tc('warningTip.emailInvaild'), type: 'email' }],
      emergencyMobile: [
        { required: true, pattern: /^[0-9]+$/, message: this.$tc('warningTip.mobileInvaild'), whitespace: true },
      ],

      enName: [{ message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      name: [{ message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      selector: [{ required: true, message: this.$tc('pleaseSelect') }],
      sourceId: [{ required: true, message: this.$tc('pleaseSelect') }],
      relationship: [{ required: true, message: this.$tc('pleaseSelect') }],
      countryId: [{ required: true, message: this.$tc('pleaseSelect') }],
      mobile: [
        { required: true, pattern: /^[0-9]+$/, message: this.$tc('warningTip.mobileInvaild'), whitespace: true },
      ],
      // schoolNowExtra: [{ message: this.$tc('warningTip.valueInvaild'), min: 1, max: 50 }],
      guardianName: [{ message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      guardianEnName: [{ message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      guardianMobile: [
        { required: true, pattern: /^[0-9]+$/, message: this.$tc('warningTip.mobileInvaild'), whitespace: true },
      ],
      guardianRelationship: [{ required: true, message: this.$tc('pleaseSelect') }],
      guardianCountryId: [{ required: true, message: this.$tc('pleaseSelect') }],
      guardianHighestQualification: [{ required: true, message: this.$tc('pleaseSelect') }],
      guardianGraduatedFrom: [
        {
          required: true,
          message: this.$tc('warningTip.schoolExtraInvaild'),
          max: 50,
          min: 1,
          whitespace: true,
        },
      ],
      guardianWorkUnit: [
        { required: true, message: this.$tc('warningTip.addressInvaild'), max: 50, min: 1, whitespace: true },
      ],
      guardianPosition: [
        {
          required: true,
          message: this.$tc('warningTip.positionInvaild'),
          max: 50,
          min: 1,
          whitespace: true,
        },
      ],

      wxid: [
        {
          required: true,
          message: this.$t('warningTip.nameInvaild'),
          whitespace: true,
        },
      ],

      guardianEmail: [{ required: true, message: this.$tc('warningTip.emailInvaild'), type: 'email' }],
      lastName: [{ required: true, message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      firstName: [{ required: true, message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      birthday: [{ required: true, message: this.$tc('pleaseSelect') }],
      highestQualification: [{ required: true, message: this.$tc('pleaseSelect') }],
      employer: [
        { required: true, message: this.$tc('warningTip.workUnitInvaild'), max: 50, min: 1, whitespace: true },
      ],
      workUnit: [
        { required: true, message: this.$tc('warningTip.workUnitInvaild'), max: 50, min: 1, whitespace: true },
      ],
      workAddress: [
        { required: true, message: this.$tc('warningTip.addressInvaild'), max: 50, min: 1, whitespace: true },
      ],
      email: [{ required: true, message: this.$tc('warningTip.emailInvaild'), type: 'email', trigger: 'blur' }],
      enter: [{ required: true, message: this.$tc('pleaseEnter') }],
      position: [
        {
          required: true,
          message: this.$tc('warningTip.positionInvaild'),
          max: 50,
          min: 1,
          whitespace: true,
        },
      ],
      graduatedFrom: [
        {
          required: true,
          message: this.$tc('warningTip.schoolExtraInvaild'),
          max: 50,
          min: 1,
          whitespace: true,
        },
      ],
    };
  }

  public get guradianRules() {
    return {
      enName: [{ message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      name: [{ required: true, message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      selector: [{ required: true, message: this.$tc('pleaseSelect') }],
      sourceId: [{ required: true, message: this.$tc('pleaseSelect') }],
      relationship: [{ required: true, message: this.$tc('pleaseSelect') }],
      countryId: [{ required: true, message: this.$tc('pleaseSelect') }],
      email: [{ required: true, message: this.$tc('warningTip.emailInvaild'), type: 'email', trigger: 'blur' }],
      highestQualification: [{ required: true, message: this.$tc('pleaseSelect') }],

      workUnit: [
        { required: true, message: this.$tc('warningTip.workUnitInvaild'), max: 50, min: 1, whitespace: true },
      ],
      mobile: [
        { required: true, pattern: /^[0-9]+$/, message: this.$tc('warningTip.mobileInvaild'), whitespace: true },
      ],
      position: [
        {
          required: true,
          message: this.$tc('warningTip.positionInvaild'),
          max: 50,
          min: 1,
          whitespace: true,
        },
      ],
      graduatedFrom: [
        {
          required: true,
          message: this.$tc('warningTip.schoolExtraInvaild'),
          max: 50,
          min: 1,
          whitespace: true,
        },
      ],
    };
  }

  public get emergencyRules() {
    return {
      name: [{ required: true, message: this.$tc('warningTip.nameInvaild'), min: 1, max: 50 }],
      relationship: [{ required: true, message: this.$tc('pleaseSelect') }],
      email: [{ required: true, message: this.$tc('warningTip.emailInvaild'), type: 'email', trigger: 'blur' }],
      mobile: [
        { required: true, pattern: /^[0-9]+$/, message: this.$tc('warningTip.mobileInvaild'), whitespace: true },
      ],
    };
  }
  public get locale(): string {
    return this.$i18n.locale;
  }
  public showModal() {
    this.visible = true;
  }
  public onChange(values: any, options: any): void {
    this.data.relationship = values;
  }
  public getFormValues(values: any = null): any {
    if (values !== null) {
      this.isWrong = false;
      this.formValues = values;
    } else {
      this.isWrong = true;
    }
  }
  public handleSubmit() {
    this.confirmLoading = true;
    const parentForm = this.$refs.parentForm as any;
    parentForm.validate(valid => {
      if (!valid) {
        this.confirmLoading = false;
        return false;
      } else {
        if (
          !this.data.name &&
          !this.data.enName
          // ||
          // (!this.isOneParent && !this.data.guardianResponse.name && !this.data.guardianResponse.enName)
        ) {
          this.confirmLoading = false;
          this.$message.error(this.$tc('applicationForm.tip1'));
        } else if (this.data.guardianDetailInfo && !this.data.guardianName && !this.data.guardianEnName) {
          this.confirmLoading = false;
          this.$message.error(this.$tc('applicationForm.tip1'));
        } else {
          const request = {
            ...this.data,
            areaCode: this.areaCode,
            accountAreaCode: this.accountAreaCode,
            guardianRequest:
              // JSON.stringify(this.data.guardianDetailInfo) !== '{}'
              this.data.guardianMobile
                ? {
                    name: this.data.guardianName,
                    enName: this.data.guardianEnName,
                    mobile: this.data.guardianMobile,
                    relationship: this.data.guardianRelationship,
                    countryId: this.data.guardianCountryId,
                    highestQualification: this.data.guardianHighestQualification,
                    graduatedFrom: this.data.guardianGraduatedFrom,
                    workUnit: this.data.guardianWorkUnit,
                    position: this.data.guardianPosition,
                    email: this.data.guardianEmail,
                  }
                : null,
            emergencyContactRequest:
              // JSON.stringify(this.data.emergencyContactResponse) !== '{}'
              this.data.emergencyContactFlag == false && this.data.emergencyMobile
                ? {
                    name: this.data.emergencyName,
                    relationship: this.data.emergencyRelationship,
                    mobile: this.data.emergencyMobile,
                    email: this.data.emergencyEmail,
                  }
                : null,
            // guardianRequest: JSON.stringify(this.guardianDetailInfo) !== '{}' ? this.guardianDetailInfo : null,
            // emergencyContactRequest:
            //   JSON.stringify(this.emergencyContactResponse) !== '{}' ? this.emergencyContactResponse : null,

            emergencyContactFlag: this.data.emergencyContactFlag,
          };
          // if (request.emergencyContactRequest) {
          //   this.$nextTick(()=>{
          //     this.data.emergencyContactFlag=false
          //   })
          // }
          KunshanApplicationController.updateParent(request)
            .then(() => {
              this.$message.success(this.$tc('changeSuccess'));
              // this.$nextTick(()=>{
              //   this.data.emergencyName= this.data.emergencyContactResponse.emergencyName
              //   this.data.emergencyRelationship= this.data.emergencyContactResponse.relationship
              //   this.data.emergencyMobile= this.data.emergencyContactResponse.mobile
              //   this.data.emergencyEmail= this.data.emergencyContactResponse.email
              // })
              this.$emit('refresh');
            })
            .finally(() => {
              this.visible = false;
              this.confirmLoading = false;
            });
        }
      }
    });
  }
  public addParent(flag: boolean): void {
    this.isOneParent = flag;
  }
  public handleCancel() {
    this.visible = false;
  }
  public callback(): void {
    this.$message.success(this.$tc('changeSuccess'));
  }
  public handlePhoneOfCountryChange(value: any, option?: any): void {
    this.areaCodeKey = value ? value : 1;
    const res: any = this.$store.state.countryList.filter((item: any) => item.key === value);
    if (res.length > 0) {
      this.areaCode = res[0].extraValue;
    }
  }
  public handleSourceChange(value: number): void {
    this.parentDetailInfo.sourceId = value;
    this.data.sourceExtra = '';
    this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(value) ? true : false;
  }
  public handleAccountAreaCodeKeyChange(value: any, option?: any): void {
    this.accountAreaCodeKey = value ? value : 1;
    const res: any = this.$store.state.countryList.filter((item: any) => item.key === value);
    if (res.length > 0) {
      this.accountAreaCode = res[0].extraValue;
    }
  }
  public edit(): void {
    this.$emit('changeIsEdit');
  }
  public validateMobile() {
    const form = this.$refs.parentForm as any;
    form.validateField(['mobile']);
  }
}
